module.exports = __webpack_public_path__ + "img/40_38_074_420.18d5943a.jpg";